import React, {Component} from "react";
import TagsInput from "react-tagsinput";
import {toast} from "react-toastify";
import ApiConnect from "../../../../Utils/ApiConnect";
import BarcodeScanner from "../../../Components/BarcodeScanner";

export default class EditProduct extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productId: props.match.params.id || "",
      isLoading: true,
      categoryName: [],
      storeName: [],
      brandName: [],
      text: "",
      Fdata: [],
      tags: [],
      formError: "",
      productImages: [],
      previewImage: [],
      componentsLoad: false,
      btnDisable: false,
    };
  }

  componentDidMount() {
    ApiConnect.get(
      `/Module/Inventory/Product/Details?id=${this.state.productId}`
    )
      .then((response) => {
        this.loadComponets();
        this.setState({
          Fdata: response.data,
          tags: response.data.tags,
          previewImage: response.data.image,
        });
      })
      .catch((error) => console.log(error));
  }
  loadComponets() {
    if (!this.state.componentsLoad) {
      ApiConnect.get("/Module/Inventory/Product/Components")
        .then((response) => {
          this.setState({
            brandName: response.data.brand,
            categoryName: response.data.category,
            storeName: response.data.godown,
            componentsLoad: true,
          });
        })
        .catch((error) => console.log(error));
    }
  }
  imageHandleChange(e) {
    if (e.target.files) {
      const fileArray = Array.from(e.target.files).map((file) =>
        URL.createObjectURL(file)
      );
      this.setState({ productImages: e.target.files, previewImage: fileArray });
    }
  }
  handleChange = (e) => {
    const newData = { ...this.state.Fdata };
    console.log(e)
    if (!e.target) {
      newData["barcode"] = e;
    } else {
      newData[e.target.name] = e.target.value;
    }

    this.setState({ Fdata: newData });
  };
  submitHandler(e) {
    e.preventDefault();
    this.setState({ btnDisable: true });
    let formData = new FormData();
    formData.append("id", this.state.Fdata.id || "");
    formData.append("name", this.state.Fdata.name || ""); //append the values with key, value pair
    formData.append("page_title", this.state.Fdata.page_title || "");
    formData.append("slug", this.state.Fdata.slug || "");
    formData.append("description", this.state.Fdata.description || "");
    formData.append("category", this.state.Fdata.category || "");
    formData.append("godown", this.state.Fdata.godown || "");
    formData.append("brand", this.state.Fdata.brand || "");
    formData.append("productsize", this.state.Fdata.productsize || "");
    formData.append("minqty", this.state.Fdata.minqty || "");
    formData.append("qtyinpack", this.state.Fdata.qtyinpack || "");
    formData.append("pvat", this.state.Fdata.pvat || "");
    formData.append("webview", this.state.Fdata.webview || "");
    formData.append("costprice", this.state.Fdata.costprice || "");
    formData.append("sellingprice", this.state.Fdata.sellingprice || "");
    formData.append("unit", this.state.Fdata.unit || "");
    formData.append("productcoupon", this.state.Fdata.slug || "");
    formData.append("tags", JSON.stringify(this.state.tags));
    formData.append("publishdate", this.state.Fdata.publishdate || "");
    formData.append("publishtime", this.state.Fdata.publishtime || "");
    formData.append("barcode", this.state.Fdata.barcode || "");
    formData.append("mrp", this.state.Fdata.mrp || "");
    for (let i = 0; i < this.state.productImages.length; i++) {
      formData.append("images_files[]", this.state.productImages[i]);
    }

    ApiConnect({
      method: "post",
      url: "/Module/Inventory/Product/EditProduct",
      data: formData,
    })
      .then((response) => {
        this.setState({ btnDisable: false });
        if (response.data.status === 201) {
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
          this.setState({
            Fdata: [],
            CategoryImages: [],
            previewImage: [],
            tags: [],
          });
          this.props.history.push("/dashboard/Inventory/Products", "edit");
        } else {
          this.setState({ formError: response.data.message });
        }
      })
      .catch((error) => console.log(error));
  }
  handleChangeTag(tag) {
    this.setState({ tags: tag });
  }
  render() {
    const product = this.state.Fdata;
    return (
      <form onSubmit={(e) => this.submitHandler(e)}>
        <p className="text-danger">{this.state.formError}</p>
        <div className="row g-3 mb-3">
          <div className="col-xl-4 col-lg-4">
            <BarcodeScanner
              fallback={this.handleChange}
              value={this.state.Fdata["barcode"] || ""}
            />
            <div className="card mb-3">
              <div className="card-header py-3 d-flex justify-content-between align-items-center bg-transparent border-bottom-0">
                <h6 className="m-0 fw-bold">Pricing Info</h6>
              </div>
              <div className="card-body">
                <div className="row g-3 align-items-center">
                  <div className="col-md-12">
                    <label className="form-label">Product Cost Price</label>
                    <input
                      type="text"
                      value={product.costprice}
                      name="costprice"
                      className="form-control"
                      placeholder="350"
                      onChange={(e) => this.handleChange(e)}
                    />
                  </div>
                  <div className="col-md-12">
                    <label className="form-label">Product Selling Price</label>
                    <input
                      type="text"
                      value={product.sellingprice}
                      name="sellingprice"
                      className="form-control"
                      placeholder="355"
                      onChange={(e) => this.handleChange(e)}
                    />
                  </div>
                  <div className="col-md-12">
                    <label className="form-label">Product MRP</label>
                    <input
                      type="text"
                      value={product.mrp}
                      name="mrp"
                      className="form-control"
                      placeholder="355"
                      onChange={(e) => this.handleChange(e)}
                    />
                  </div>
                  <div className="col-md-12">
                    <label className="form-label">Product Coupon</label>
                    <input
                      type="text"
                      name="productcoupon"
                      className="form-control"
                      placeholder="BATTT-XA47"
                      onChange={(e) => this.handleChange(e)}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="card mb-3">
              <div className="card-header py-3 d-flex justify-content-between align-items-center bg-transparent border-bottom-0">
                <h6 className="m-0 fw-bold">Product Details</h6>
              </div>
              <div className="card-body">
                <div className="row g-3 align-items-center">
                  <div className="col-md-12">
                    <label className="form-label">Publish Date</label>
                    <input
                      name="publishdate"
                      type="date"
                      className="form-control w-100"
                      placeholder="2021-03-28"
                      onChange={(e) => this.handleChange(e)}
                    />
                  </div>
                  <div className="col-md-12">
                    <label className="form-label">Publish Time</label>
                    <input
                      name="publishtime"
                      type="time"
                      className="form-control w-100"
                      placeholder="10:30"
                      onChange={(e) => this.handleChange(e)}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="card mb-3">
              <div className="card-header py-3 d-flex justify-content-between align-items-center bg-transparent border-bottom-0">
                <h6 className="m-0 fw-bold">Tags</h6>
              </div>
              <div className="card-body">
                <div className="form-group demo-tagsinput-area">
                  <div className="form-line">
                    <TagsInput
                      value={this.state.tags}
                      onChange={(e) => this.handleChangeTag(e)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xl-8 col-lg-8">
            <div className="card mb-3">
              <div className="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0">
                <h6 className="mb-0 fw-bold ">Basic information</h6>
              </div>
              <div className="card-body">
                <div className="row g-3 align-items-center">
                  <div className="col-md-6">
                    <label className="form-label">Name</label>
                    <input
                      type="text"
                      name="name"
                      value={product.name}
                      className="form-control"
                      placeholder="Oculus VR"
                      onChange={(e) => this.handleChange(e)}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Page Title</label>
                    <input
                      type="text"
                      value={product.name}
                      name="page_title"
                      className="form-control"
                      placeholder="Gaming VR"
                      onChange={(e) => this.handleChange(e)}
                    />
                  </div>
                  <div className="col-md-12">
                    <label className="form-label">Product Identifier URL</label>
                    <div className="input-group mb-3">
                      <span className="input-group-text">
                        https://YourWebsite.com/product/
                      </span>
                      <input
                        type="text"
                        value={product.slug}
                        name="slug"
                        className="form-control"
                        placeholder="NarayaniGroup"
                        onChange={(e) => this.handleChange(e)}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <label className="form-label">Product Description</label>
                    <textarea
                      className="form-control"
                      value={product.description}
                      name="description"
                      rows="6"
                      onChange={(e) => this.handleChange(e)}
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div className="card mb-3">
              <div className="card-header py-3 d-flex justify-content-between align-items-center bg-transparent border-bottom-0">
                <h6 className="m-0 fw-bold">Inventory Info</h6>
              </div>
              <div className="card-body">
                <div className="row g-3 align-items-center">
                  <div className="col-md-6">
                    <label className="form-label">Category Select</label>
                    <select
                      name="category"
                      value={product.category}
                      className="form-control"
                      onChange={(e) => this.handleChange(e)}
                    >
                      <option defaultValue>Select Category</option>
                      {this.state.categoryName.map((key, index) => (
                        <option value={key.catid} key={index}>
                          {key.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Godown Select</label>
                    <select
                      name="godown"
                      value={product.godown}
                      className="form-control"
                      onChange={(e) => this.handleChange(e)}
                    >
                      <option defaultValue>Select Godown</option>
                      {this.state.storeName.map((key, index) => (
                        <option value={key.godownid} key={index}>
                          {key.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Brand Select</label>
                    <select
                      name="brand"
                      value={product.brand}
                      className="form-control"
                      onChange={(e) => this.handleChange(e)}
                    >
                      <option defaultValue>Select Brand</option>
                      {this.state.brandName.map((key, index) => (
                        <option value={key.id} key={index}>
                          {key.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Product Size/Weight</label>
                    <input
                      type="text"
                      value={product.productsize}
                      name="productsize"
                      className="form-control"
                      placeholder="12"
                      onChange={(e) => this.handleChange(e)}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Quantity in Pack</label>
                    <input
                      type="text"
                      value={product.qtyinpack}
                      name="qtyinpack"
                      className="form-control"
                      placeholder="1"
                      onChange={(e) => this.handleChange(e)}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Measure Unit</label>
                    <input
                      type="text"
                      value={product.unit}
                      name="unit"
                      className="form-control"
                      placeholder="1"
                      onChange={(e) => this.handleChange(e)}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Product Vat</label>
                    <input
                      type="text"
                      value={product.pvat}
                      name="pvat"
                      className="form-control"
                      placeholder="0"
                      onChange={(e) => this.handleChange(e)}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Minimum Stock Quantity</label>
                    <input
                      type="text"
                      value={product.minqty}
                      name="minqty"
                      className="form-control"
                      placeholder="0"
                      onChange={(e) => this.handleChange(e)}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Web Visibility Status</label>
                    <select
                      name="webview"
                      value={product.webview}
                      className="form-control"
                      onChange={(e) => this.handleChange(e)}
                    >
                      <option defaultValue>Web Visibility</option>
                      <option value="1">Published</option>
                      <option value="0">Scheduled</option>
                      <option value="0">hidden</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div className="card mb-3">
              <div className="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0">
                <h6 className="mb-0 fw-bold ">Images</h6>
              </div>
              <div className="card-body">
                <div className="file-group">
                  <input
                    type="file"
                    id="file"
                    multiple
                    accept="image/*"
                    onChange={(e) => this.imageHandleChange(e)}
                  />
                  <label htmlFor="file">
                    <span className="material-icons-outlined">upload_file</span>
                  </label>
                </div>
                <div className="row">
                  {this.state.previewImage.map((image, index) => (
                    <div className="col" key={index}>
                      <img
                        className="img-thumbnail"
                        width="150"
                        src={image}
                        alt={`doc${index}`}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer className="card-footer flexbox flex-justified text-center">
          <button
            className="btn btn-success text-white fw-500"
            disabled={this.state.btnDisable}
          >
            Edit Change
          </button>
        </footer>
      </form>
    );
  }
}
